import React from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'
import * as S from './styled'

/**
  Uso:
  const options = [
    { value: 0, label: 'Op1' },
    { value: 1, label: 'Op2' },
    { value: 2, label: 'Op3' }
  ]

  <InputSelect
    name={'default'} -> identificador del input
    label={'Concessions'} -> label del input si lo tiene
    placeholder={'placeholder'} -> placeholder custom (label por defecto)
    iconColor={'white'} -> color del icono si lo tiene (verde por defecto)
    value={{value: 0, label: 'Op1'}} -> value inicial del select
    options={options} -> Array de opciones
    icon={SearchIcon} -> Source del icono (por defecto no tiene)
    errorMsg={'Campo obligatorio'} -> Mensaje de error en la validación
    isDisabled={true} -> Botón deshabilitado (por defecto false)
    isSearchable={true} -> Si quieres realizarse búsquedas en las opciones
    handleChange={(value) => console.log(value)} -> Función que devuelve el valor seleccionado ({value: 0, label:'Op1'})
    top={'top'} -> Posicionado relativo del label si procede
  />
*/
const InputSelect = ({
  name,
  value,
  label,
  errorMsg,
  options,
  placeholder,
  isDisabled,
  handleChange,
  isClearable,
  isSearchable,
  className,
  top,
}) => {
  /**
   * Looks for value in current options array to make sure the value is always
   * displayed in the proper language (options array is always updated on language change,
   * while value could have been stored in the state with a previous language).
   */
  const _value = options?.find(option => value?.value === option?.value)

  return (
    <S.InputSelectContainer errorMsg={errorMsg} isDisabled={isDisabled} className={className}>
      {label && (
        <S.InputTextLabel htmlFor={name} top={top}>
          <span className='text'>{label}</span>
        </S.InputTextLabel>
      )}
      <Select
        id={name}
        name={name}
        defaultValue={_value}
        value={_value}
        classNamePrefix='input-select'
        options={options}
        placeholder={placeholder}
        isDisabled={isDisabled || !options}
        onChange={handleChange && (val => handleChange(val))}
        isClearable={isClearable}
        isSearchable={isSearchable}
        isLoading={!options}
        openMenuOnFocus
        menuPlacement='top'
        onFocus={() => {}}
      />
    </S.InputSelectContainer>
  )
}

InputSelect.defaultProps = {
  name: 'default-name',
  value: {},
  label: '',
  errorMsg: null,
  options: [],
  placeholder: '',
  isDisabled: false,
  handleChange: () => {},
  isClearable: false,
  isSearchable: false,
  className: '',
  top: '',
}

InputSelect.propTypes = {
  name: PropTypes.string,
  value: PropTypes.object,
  label: PropTypes.string,
  errorMsg: PropTypes.string,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool,
  handleChange: PropTypes.func,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
  className: PropTypes.string,
  top: PropTypes.string,
}

export default InputSelect
